// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/icon/icon.component.scss
// module id = 365
// module chunks = 0